import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ProgressBar from "react-bootstrap/ProgressBar";

const RecoveryForm = ({liveProgress, structuredData, _tC}) => {
    const [stats, setStats] = useState({
        devices: 0,
        dev_processed: 0,
        errors: 0,
        data_messages: 0,
        not_messages: 0,
        exists: 0,
        mess_processed: 0,
        mess_not_processed: 0,
        messages_total: 0,
        started_at: "",
    });

    useEffect(() => {
        if (structuredData) {
            setStats(structuredData);
        }
    }, [structuredData]);

    return (
        <div className="recovery-process-form">
            <div className="row mt-3">
                <div className="col-12">
                    <div className=" ">
                        <div className="">
                            {stats.devices > 0 ? (
                                <>
                                    <div className="row mb-4">
                                        <div className="col-lg-2 col-md-4 col-6 mb-3">
                                            <div className=" border-primary">
                                                <div className=" text-center p-2">
                                                    <h4 className="text-primary mb-1">
                                                        {stats.devices}
                                                    </h4>
                                                    <small className="text-muted">
                                                        {_tC("total_devices")}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-6 mb-3">
                                            <div className=" border-success">
                                                <div className=" text-center p-2">
                                                    <h4 className="text-success mb-1">
                                                        {stats.dev_processed}
                                                    </h4>
                                                    <small className="text-muted">
                                                        {_tC("processed_devices")}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-6 mb-3">
                                            <div className=" border-danger">
                                                <div className=" text-center p-2">
                                                    <h4 className="text-danger mb-1">
                                                        {stats.errors}
                                                    </h4>
                                                    <small className="text-muted">
                                                        {_tC("errors")}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-6 mb-3">
                                            <div className=" border-info">
                                                <div className=" text-center p-2">
                                                    <h4 className="text-info mb-1">
                                                        {stats.data_messages}
                                                    </h4>
                                                    <small className="text-muted">
                                                        {_tC("with_Messages")}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-6 mb-3">
                                            <div className=" border-warning">
                                                <div className=" text-center p-2">
                                                    <h4 className="text-warning mb-1">
                                                        {stats.not_messages}
                                                    </h4>
                                                    <small className="text-muted">
                                                        {_tC("without_Messages")}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-6 mb-3">
                                            <div className=" border-secondary">
                                                <div className=" text-center p-2">
                                                    <h4 className="text-secondary mb-1">
                                                        {stats.exists}
                                                    </h4>
                                                    <small className="text-muted">
                                                        {_tC("alreadyExists")}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <h6 className="text-primary mb-3">
                                                <FontAwesomeIcon
                                                    icon="network-wired"
                                                    className="me-2"
                                                />
                                                {_tC("progress_devices")}
                                            </h6>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>{_tC("processed_devices")}:</span>
                                                <strong>
                                                    {stats.dev_processed} {_tC("de")}{" "}
                                                    {stats.devices}
                                                </strong>
                                            </div>
                                            <ProgressBar
                                                now={
                                                    stats.devices > 0
                                                        ? (stats.dev_processed /
                                                              stats.devices) *
                                                          100
                                                        : 0
                                                }
                                                variant="primary"
                                                style={{height: "25px"}}
                                                label={`${
                                                    stats.devices > 0
                                                        ? Math.round(
                                                              (stats.dev_processed /
                                                                  stats.devices) *
                                                                  100
                                                          )
                                                        : 0
                                                }%`}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <h6 className="text-success mb-3">
                                                <FontAwesomeIcon
                                                    icon="envelope"
                                                    className="me-2"
                                                />
                                                {_tC("progress_messages")}
                                            </h6>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>{_tC("with_Messages")}:</span>
                                                <strong>
                                                    {stats.mess_processed} {_tC("de")}{" "}
                                                    {stats.messages_total}{" "}
                                                    {_tC("processed")}
                                                </strong>
                                            </div>
                                            <ProgressBar
                                                now={
                                                    stats.messages_total > 0
                                                        ? (stats.mess_processed /
                                                              stats.messages_total) *
                                                          100
                                                        : 0
                                                }
                                                variant="success"
                                                style={{height: "25px"}}
                                                label={`${
                                                    stats.messages_total > 0
                                                        ? Math.round(
                                                              (stats.mess_processed /
                                                                  stats.messages_total) *
                                                                  100
                                                          )
                                                        : 0
                                                }%`}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="text-center p-4">
                                            <p className="mt-2 text-muted">
                                                {_tC("loading")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {liveProgress && (
                                <div className="mt-4">
                                    <h6 className="text-primary">
                                        <FontAwesomeIcon
                                            icon="terminal"
                                            className="me-2"
                                        />
                                        {_tC("recovery_log")}
                                    </h6>
                                    <div
                                        className="border rounded p-3 bg-light"
                                        style={{
                                            overflowY: "auto",
                                            fontFamily: "monospace",
                                            fontSize: "0.85em",
                                            lineHeight: "1.4",
                                        }}
                                        dangerouslySetInnerHTML={{__html: liveProgress}}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecoveryForm;
